import { documentationActions } from 'src/redux/actions/constant';

const { SUCCESS_GET_PROVIDER_LIST, FAILURE_GET_PROVIDER_LIST, LOADING_GET_PROVIDER_LIST } =
documentationActions;

const intialState: object = {
  response: null,
  areGettingTherapist: false,
  loading: false,
};

export const getAllTherapistReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_PROVIDER_LIST: {
      return {
        ...state,
        response: action.payload,
        areGettingTherapist: true,
        loading: false,
      };
    }
    case FAILURE_GET_PROVIDER_LIST: {
      return {
        ...state,
        response: action.payload,
        areGettingTherapist: false,
        loading: false,
      };
    }
    case LOADING_GET_PROVIDER_LIST:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
